import React from 'react';
import PropTypes from 'prop-types';
// import { useQuery } from 'react-query';

const QartodLabel = (props) => {
  const { result } = props;

  const qartodResultMap = {
    1: {
      label: 'Pass',
      icon:
  <div
    style={{
      background: '#49AA19',
      width: 12,
      height: 12,
      border: '1px solid #80C45E',
      borderRadius: '50%',
    }}
  />,
    },
    2: {
      label: 'Not Evaluated',
      icon:
  <div
    style={{
      background: 'rgba(255, 255, 255, 0.8)',
      width: 12,
      height: 12,
      border: '1px solid white',
      borderRadius: '50%',
    }}
  />,
    },
    3: {
      label: 'Suspect',
      icon:
  <div
    style={{
      background: '#D89614',
      width: 12,
      height: 12,
      border: '1px solid #E4B65B',
      borderRadius: '50%',
    }}
  />,
    },
    4: {
      label: 'Fail',
      icon:
  <div
    style={{
      background: '#DC4446',
      width: 12,
      height: 12,
      border: '1px solid #E77C7E',
      borderRadius: '50%',
    }}
  />,
    },
    9: {
      label: 'Missing',
      icon:
  <div
    style={{
      background: 'transparent',
      width: 12,
      height: 12,
      border: '1px solid white',
      borderRadius: '50%',
    }}
  />,
    },
  };

  const testResult = qartodResultMap[result];

  if (!testResult) {
    return null;
  }

  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      {testResult.icon}
      <span
        style={{
          color: '#D9DDE2',
          fontWeight: 400,
        }}
      >
        {testResult.label}
      </span>
    </span>
  );
};
QartodLabel.propTypes = {
  result: PropTypes.number,
};

QartodLabel.defaultProps = {
  result: 9,
};

export default QartodLabel;
